import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    // 

    createChannel = new Subject();
    detailChannel = new Subject();
    repository = new CreateRepository()
    employeeChannel = new Subject();
    typeChannel = new Subject()
  
    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchEmployee = async (query) => {
        this.employeeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEmployee(query).then((result) => {
            this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.employeeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchType = async (query) => {
        this.typeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchType(query).then((result) => {
            this.typeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.typeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    
}

export default CreateBloc